import {PreviousRuns} from "./PreviousRuns";
import {sortAscendingWithNullsLast} from "../../../utils/sorting";
import RunId from "./RunId";
import {CONFIG_TYPES, retailerIdDisplay} from "../../Configurations/FileTypes";
import {retailerDisplay} from "../../../utils/retailerDisplayFormatter";
import {queryParamFilterReactTable7} from "../../../utils/QueryParamFilter";
import FileTypeConfig from "./FileTypeConfig";
import matchSorter from "match-sorter";
import FtpConfig from "./FtpConfig";
import IngestionLogsFileLink from "./IngestionLogsFileLink";
import IngestionLogsActions from "./IngestionLogsActions";
import React from "react";
import {getRetailerName} from '../../../utils/localCache/retailerMapCache';
import ReactTableFilterDropdown from "../../ReactTable/ReactTableFilterDropdown";
import {updateQueryStringForState} from "../../../utils/urlBuilder";
import _ from "lodash";
import Feedback from "./Feedback";

export const retailerQueryStringKey = 'retailer';
export const retailerColumnId = 'Retailer';
export const fileTypeColumnId = 'fileType';
export const fileTypeQueryStringKey = 'fileType';
export const fileNameColumnId = 'fileName';
export const fileNameQueryStringKey = 'fileName';

export function getIngestionLogsColumns(salesforceRetailers) {

    const configTypesOptions = Object.values(CONFIG_TYPES)
        .filter(config => config.getName() !== 'file_type')
        .map(config => ({label: config.getName(), value: config.getName()}))

    return [
        {
            header: 'Attempts',
            accessorKey: 'previousRuns',
            className: 'non-numeric-field',
            enableColumnFilter: false,
            cell: PreviousRuns,
            size: 150,
            sortingFn: (rowA, rowB) => {
                const previousRunsA = rowA?.original?.previousRuns.length;
                const previousRunsB = rowB?.original?.previousRuns.length;
                return sortAscendingWithNullsLast(previousRunsA, previousRunsB);
            }
        },
        {
            header: 'Run Id',
            id: 'runId',
            accessorKey: 'runId',
            enableColumnFilter: false,
            cell: RunId,
            className: 'non-numeric-field line-wrap-field',
            minSize: 150,
            maxSize: 200
        },
        {
            header: 'Feedback',
            id: 'feedback',
            className: 'non-numeric-field',
            enableColumnFilter: false,
            size: 160,
            accessorFn: (row) => row,
            sortingFn: (rowA, rowB) => {
                const knownItemPercentageA = rowA?.original?.cleansedInputCount && (rowA.original.totalExistingUPCCount / rowA.original.cleansedInputCount);
                const knownItemPercentageB = rowB?.original?.cleansedInputCount && (rowB.original.totalExistingUPCCount / rowB.original.cleansedInputCount);
                return sortAscendingWithNullsLast(knownItemPercentageA, knownItemPercentageB);
            },
            cell: Feedback
        },
        {
            header: 'Retailer',
            id: retailerColumnId,
            accessorKey: 'retailerId',
            cell: ({getValue, row}) => retailerIdDisplay(salesforceRetailers, getValue(), row),
            filter: queryParamFilterReactTable7(retailerQueryStringKey),
            filterFn: (row, columnIds, filterValue) => {
                if (!filterValue) {
                    return true;
                }
                const retailerId = row.original.retailerId
                if (!retailerId) {
                    return false
                }
                const retailerIdString = retailerId.toString();
                const retailChain = getRetailerName(retailerId);

                const searchableValue = retailChain ? retailerDisplay(retailerId, retailChain) : retailerIdString
                return searchableValue.toUpperCase().includes(filterValue.toUpperCase())
            } ,
            className: 'non-numeric-field line-wrap-field',
            minSize: 150
        },
        {
            header: 'File Type',
            accessorKey: fileTypeColumnId,
            cell: FileTypeConfig,
            filterFn: (row, columnId, filterValue) => {
                if (_.isEmpty(filterValue)) {
                    return true;
                }
                const rowValue = row.getValue(columnId);
                if (_.isEmpty(rowValue)) {
                    return false
                }
                return rowValue.toUpperCase() === filterValue.toUpperCase()
            },
            filter: (theseProps) => {
                return <ReactTableFilterDropdown
                    id={"fileType"}
                    options={configTypesOptions}
                    onChange={(selected) => {
                        const queryString = selected === null ? '' : selected;
                        updateQueryStringForState({[theseProps.column.id]: queryString});
                        theseProps.column.setFilterValue(selected);
                    }}
                    selectedValue={theseProps.column.getFilterValue()}
                    isClearable={true}
                />
            },
            className: 'non-numeric-field',
            size: 150
        },
        {
            header: 'File Mapping',
            accessorKey: 'ftp',
            enableColumnFilter: false,
            cell: FtpConfig,
            className: 'non-numeric-field',
            minSize: 125,
            maxSize: 175
        },
        {
            header: 'File',
            accessorKey: fileNameColumnId,
            cell: IngestionLogsFileLink,
            filter: queryParamFilterReactTable7(fileNameQueryStringKey),
            filterFn: (row, columnIds, filterValue) => matchSorter([row], filterValue, { keys: [`original.${fileNameColumnId}`] }).length > 0,
            className: 'non-numeric-field',
            minSize: 250
        },
        {
            header: 'Triggered By',
            accessorKey: 'triggeredBy',
            className: 'non-numeric-field',
            cell: (props) => {
                return <div title={props.getValue()}>{props.getValue()}</div>
            },
            minSize: 175,
            maxSize: 300
        },
        {
            header: 'Actions',
            accessorKey: 'archiveLocation',
            enableColumnFilter: false,
            cell: IngestionLogsActions,
            className: 'non-numeric-field',
            size: 200
        }
    ];
}
